import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar-wedget-wrap" }
const _hoisted_2 = { class: "sidebar-wedget" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled services" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sidebar-wedget internet" }, [
      _createElementVNode("span", { class: "top-title" }, "خدمات البث"),
      _createElementVNode("h2", null, " تجربة مشاهدة بلا حدود: اكتشف عالم الترفيه الرقمي الفائق ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-title" }, "خدمات أخرى", -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            to: "/services-details",
            class: "d-flex justify-content-between align-items-center"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "name" }, "باقات IPTV", -1),
              _createElementVNode("i", { class: "ri-arrow-right-s-fill" }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<li><a href=\"/services-details\" class=\"d-flex justify-content-between align-items-center\"><span class=\"name\">القنوات الرياضية</span><i class=\"ri-arrow-right-s-fill\"></i></a></li><li><a href=\"/services-details\" class=\"d-flex justify-content-between align-items-center\"><span class=\"name\">مكتبة الأفلام</span><i class=\"ri-arrow-right-s-fill\"></i></a></li><li><a href=\"/services-details\" class=\"d-flex justify-content-between align-items-center\"><span class=\"name\">الدعم الفني والتقني</span><i class=\"ri-arrow-right-s-fill\"></i></a></li><li><a href=\"/services-details\" class=\"d-flex justify-content-between align-items-center\"><span class=\"name\">إعداد الشاشات الذكية</span><i class=\"ri-arrow-right-s-fill\"></i></a></li>", 4))
      ])
    ])
  ]))
}